@if (inviteToken) {
  <ng-container>
    <ng-template #modalHost></ng-template>
  </ng-container>
}
